import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { TPVServices } from "../../../services";
import { Globals } from "../../../../../globals";
import { ConfigurationCashsCreatePage } from '../../../../configuration/configuration-cashs/configuration-cashs-create/configuration-cashs-create';
import { ConfigurationServices } from '../../../../configuration/services';
import { AddonsTriggerVersionProPage } from '../../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the TpvTicketSelectedCashPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-tpv-ticket-selected-cash',
    templateUrl: 'tpv-ticket-selected-cash.html',
})
export class TpvTicketSelectedCashPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public tpvServices: TPVServices,
        public globals: Globals,
        public configurationServices: ConfigurationServices) {
        this.globals.GAtrackView('TPV', 'TPV - Cashs - List', this.globals.restaurant.email, 'View', 'List cashs TPV', 'TPV', '');

    }

    selectCash(cash) {
        if (cash._active) {
            this.tpvServices.tableUpdateCash(cash);
            this.navCtrl.pop();
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    openCreateCash() {
        //Si tiene un limite de cajas para crear
        if (this.globals.checkLimitsByLicense('config', 'multi_cash')) {
            this.navCtrl.push(ConfigurationCashsCreatePage);
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-selected-cash/tpv-ticket-selected-cash.ts